module.exports = __webpack_public_path__ + "res/img_button_bg.8f80685a0361faf342d9392962df822b.png";